
import { Button } from "@/components/ui/button";
import { Lightbulb, Sparkles } from "lucide-react";

interface SuggestedQuestionsProps {
  questions: string[];
  onSelectQuestion: (question: string) => void;
}

const SuggestedQuestions: React.FC<SuggestedQuestionsProps> = ({ 
  questions, 
  onSelectQuestion 
}) => {
  if (questions.length === 0) return null;

  return (
    <div className="w-full max-w-4xl mx-auto px-4 animate-fade-up">
      <div className="bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-950/50 dark:to-purple-950/50 rounded-xl p-4 border border-blue-200 dark:border-blue-800 shadow-sm">
        <div className="flex items-center gap-2 mb-3">
          <div className="flex items-center gap-1">
            <Sparkles className="h-4 w-4 text-blue-600 dark:text-blue-400" />
            <Lightbulb className="h-4 w-4 text-purple-600 dark:text-purple-400" />
          </div>
          <h4 className="text-sm font-semibold text-blue-900 dark:text-blue-100">
            💡 Perguntas Inteligentes sobre seu Documento:
          </h4>
        </div>
        <p className="text-xs text-blue-700 dark:text-blue-300 mb-3 opacity-90">
          Baseado na análise do documento, posso responder especificamente sobre:
        </p>
        <div className="flex flex-wrap gap-2">
          {questions.map((question, index) => (
            <Button
              key={index}
              variant="outline"
              size="sm"
              className="text-xs h-auto py-2 px-3 bg-white dark:bg-gray-900 border-blue-300 dark:border-blue-700 hover:bg-blue-50 dark:hover:bg-blue-900/50 hover:border-blue-400 dark:hover:border-blue-600 text-blue-800 dark:text-blue-200 hover:text-blue-900 dark:hover:text-blue-100 transition-all duration-200 shadow-sm hover:shadow-md min-w-0"
              onClick={() => onSelectQuestion(question)}
            >
              <span className="mr-1 shrink-0">🎯</span>
              <span className="line-clamp-2 break-words text-left leading-snug min-w-0">{question}</span>
            </Button>
          ))}
        </div>
        <div className="mt-3 pt-2 border-t border-blue-200 dark:border-blue-800">
          <p className="text-xs text-blue-600 dark:text-blue-400 flex items-center gap-1">
            <Sparkles className="h-3 w-3" />
            <span>Clique em qualquer pergunta para obter uma resposta específica e contextualizada</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuggestedQuestions;
